const condensedProposalStyle = `
@page { 
  @top-left-corner {
    content: element(headerRun);
  }
  @bottom-right-corner { 
    content: element(logoRun);
  } 
  @bottom-left-corner {
    content: element(siteRun);
  }
  @bottom-center { 
    content: element(footerRun); 
  } 
} 
.running-site {
  position: running(siteRun);
  margin-left: 45px;
  font-size: 0.8em;
  font-weight: bold;
}
.running-site a {
  color: #181A19;
}
.running-logo { 
  position: running(logoRun); 
  width: 200px;
  margin-left: -130px;
} 
.running-footer { 
  position: running(footerRun); 
  position: relative;
  width: 100%; 
  font-size: 0.7em;
  font-weight: normal;
}
.running-header {
  position: running(headerRun);
  position: absolute;
  width: 100%; 
}
section[data-type='cover'] { 
  page: cover; 
} 
@page cover {
  display: block; 
  page-break-after: always;
  background-color: rgb(237, 234, 225);
  @top-left-corner {
    content: element(coverRun);
  } 
  @bottom-right-corner {
    content: none;
  }
  @top-right-corner {
    content: none;
  }
  margin: 25mm 15mm 15mm 15mm;
}
.cover__page-header {
  position: running(coverRun);
  position: absolute;
  width: 100%; 
}
section[data-type='last-page'] { 
  page: last-page; 
}
@page last-page { 
  @top-left-corner { content: element(coverRun); }
  @top-right-corner { content: none; }
  @bottom-left-corner { content: none; } 
  @bottom-center { content: none; }
  @bottom-right-corner { content: none; } 
  margin: 25mm 15mm 15mm 15mm;
  background: rgb(237, 234, 225); 
} 
.content-section:not(#project-scope) h1:not(.condensed-pricing-summary h1) { 
  page-break-before: always; 
} 
.content-section .condensed-pricing-summary {
  page-break-before: always;
  break-before: always;
  page-break-inside: avoid !important;
  break-inside: avoid !important;
}
@page {
  margin-top: 25mm;
  margin-bottom: 25mm;
  margin-left: 15mm;
  margin-right: 15mm;
}
h1, h2, h3, hr { 
  page-break-after: avoid; 
} 
.content-section img, .content-subsection img, .content-sub-subsection img { 
  page-break-before: avoid;
}
.break-after {
  page-break-after: always;
}
.pagedjs_page_content {
  column-width: auto !important;
}
`

export default condensedProposalStyle;